import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import CardHeader from '../../../Components/cardHeader';
import FullCard from '../../../Components/fullCard';
import MapChart from '../../../Components/mapChart';
import MapMiniTable from '../../../Components/mapMiniTable';
import { useTranslation } from 'react-i18next';

const ExportMoreInsightsWorldMap = () => {
  const data = useSelector((store) => store.analytics?.activityLevel?.data?.more_insights);
  const { t } = useTranslation();
  return (
    <FullCard>
      <CardHeader
        name={t("demographicInsights")}
        customWidth="400px"
        toolTipText={t("insightsActivityTooltip")}
      />
      <Wrapper style={{display: "flex", justifyContent: "center", flexDirection: "column"}}>
        <MapChart data={data} />
        <MapMiniTable isRequired= "true" data={data} />
      </Wrapper>
    </FullCard>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export default ExportMoreInsightsWorldMap;
